import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { connect, getIn } from 'formik';
import withLabel from '../Label';
import './styles.scss';

export const Switch = ({
  formik: { values, handleChange },
  className,
  disabled,
  name,
  label,
  style,
  id,
  ...rest
}) => (
  <div
    className={cx('form-element', 'toggle-wrapper', className, { isDisabled: disabled })}
    style={style}
  >
    <label htmlFor={id || name} className={cx('toggle-switch', className)}>
      <input
        {...rest}
        name={name}
        id={id || name}
        checked={
          typeof getIn(values, name) === 'string'
            ? getIn(values, name).toLowerCase() === 'true'
            : getIn(values, name)
        }
        onChange={handleChange}
        disabled={disabled}
        type="checkbox"
      />
      <span className="slider" />
    </label>
  </div>
);

Switch.propTypes = {
  /** @ignore */
  formik: PropTypes.instanceOf(Object).isRequired,
  /** Adds a custom class to the Switch button */
  className: PropTypes.string,
  /** Adds a custom inline styles to the Switch wrapper div */
  style: PropTypes.instanceOf(Object),
  /** Disables the Switch button */
  disabled: PropTypes.bool,
  /** Sets the Name of the Switch button */
  name: PropTypes.string.isRequired,
  /** Sets an Id for the Switch button, if not passed, the id will be the name */
  id: PropTypes.string,
  label: PropTypes.string
};

Switch.defaultProps = {
  className: null,
  style: null,
  disabled: false,
  id: null,
  label: undefined
};

export default withLabel('switch')(connect(Switch));
